// extracted by mini-css-extract-plugin
module.exports = {"cnt":"Widget_cnt__1ud69","bar":"Widget_bar__2jbGG","body":"Widget_body__2_Ub7","title":"Widget_title__3hYJd"};